import { AxiosError } from "axios";
import { getAuth } from "firebase/auth";
import client from "../../api/client";
import TApiResult from "../../types/api/TApiResult";
import getErrorProperty from "./config/getErrorProperty";
import tokenNotFound from "./config/tokenNotFound";
import { MarkReadResponse,  } from "../../api/notification";

export type TApiPutBoardComment = {
  result?: MarkReadResponse;
};

export const putMarkAsReadNotifications = async (): Promise<TApiResult & TApiPutBoardComment> => {
  const auth = getAuth();
  const token = await auth.currentUser?.getIdToken();
  if (!token) return tokenNotFound;
  return await client()
    .notifications.mark_as_read.put({
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((res) => {
      return {
        isSuccess: true,
        status: 200,
        message: "",
        result: res.body
      };
    })
    .catch((e: AxiosError) => {
      const { status, message } = getErrorProperty(e, "putMarkAsReadNotifications");
      return {
        isSuccess: false,
        status: status,
        message: message,
      };
    });
};
